/**
 * 兼容不同平台的全屏方法
 */
export const requestFullscreen = (element?: any) => {
  if (!element) return;

  if (element.requestFullscreen) element.requestFullscreen();
  else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen();
  else if (element.mozRequestFullScreen) element.mozRequestFullScreen(); // Careful to the capital S
  else if (element.msRequestFullscreen) element.msRequestFullscreen();
  else if (element.webkitEnterFullscreen) element.webkitEnterFullscreen();
};
